import {useState,useEffect,useRef} from "react";
import {UrlQuery} from "biz9-react-utility";
import {Template,Storage} from "../project";
import {Log,Obj} from "biz9-utility";
import {Portal_Title,Sub_Value_Logic,Sub_Value_Type} from "biz9-portal-app";
import {Portal_Value_Type} from "biz9-portal-app";

const SubValue = (props) => {
    const query = UrlQuery();
    useEffect(() => {
            bind_edit(props);
            }, [props]);
    async function bind_edit(props) {
        if(props.edit_mode){
            const update_sub_value = (event) => {
                if(event.data?.event_handler == props.sub_value_edit.event_handler){
                    let sub_value = Sub_Value_Logic.get_sub_value(event.data.sub_value);
                    let sub_value_group =!Obj.check_is_empty(Storage.get_sub_value_group(props.sub_value_edit)) ? Storage.get_sub_value_group(props.sub_value_edit) : Sub_Value_Logic.get_sub_value_group([sub_value]);
                    if(event.data.sub_value.type != Sub_Value_Type.ITEMS){
                        if(Obj.check_is_empty(sub_value_group['sub_value_'+sub_value.value_id])){
                            sub_value_group['sub_value_'+sub_value.value_id] = {value:''};
                        }
                        sub_value_group['sub_value_'+sub_value.value_id].value = sub_value.value;
                    }else{
                        if(Obj.check_is_empty(sub_value_group['sub_value_'+sub_value.value_id])){
                            sub_value_group['sub_value_'+sub_value.value_id] = {items:[]};
                        }
                        sub_value_group['sub_value_'+sub_value.value_id].items = sub_value.items;
                    }
                    Storage.post_sub_value_group(props.sub_value_edit,sub_value_group);
                    props.update_sub_value(sub_value);
                }
            }
            window.addEventListener('message',update_sub_value);
        }
    };
        return (
                <>
                <div className="col-md-12">
                <div className="form-wrap">
                </div>
                </div>
                </>
               )
    }
    export default SubValue;
